module.exports = __webpack_public_path__ + "static/webclient-67c0f5b3d1de661e3c767b323ce6b8b0.png";